import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import PromptMessage from '@/components/UI/PromptMessage';
import { ButtonWithLoader } from '@/components/Common/ButtonWithLoader';
import { useBffApiRequest } from '@/hooks/useBffApiRequest';
import { getAvailableBonuses, getUserBonuses } from '@/store/actions/bonusesActions';
import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import BffApiService from '@/shared/bffApiService';
import { generateBffErrorMessageWithCode } from '@/utils/utils';

const CreditButton = ({ promoCode }: { promoCode: string }) => {
  const { request, loading, error, success } = useBffApiRequest();
  const intl = useIntl();
  const dispatch = useDispatch();

  const handleOnBonusCredit = () => {
    if (loading || success) {
      return;
    }

    request({
      apiMethod: BffApiService.creditBonus,
      pathParams: {
        promoCode,
      },
      successCallback: () => {
        dispatch(getUserBonuses());
        dispatch(getAvailableBonuses());
        triggerGTag(GTagEvents.user_claimed_bonus, {
          bonusCode: promoCode,
        });
      },
    });
  };

  return (
    <>
      <ButtonWithLoader
        message={intl.formatMessage({ id: 'bonusCard.claimBonusButton' })}
        onClick={handleOnBonusCredit}
        className="bg-emerald-500 hover:bg-emerald-600 !my-0 !text-base h-auto py-4 px-6"
        loading={loading}
        disabled={loading}
      />
      {error && (
        <PromptMessage
          type="error"
          message={generateBffErrorMessageWithCode(
            intl.formatMessage({ id: 'error.support' }),
            error.code,
          )}
        />
      )}
    </>
  );
};

export default CreditButton;
